module.exports = __webpack_public_path__ + "img/button-start-round.2a79ac7a.svg";